export const TERMS_AND_CONDITIONS = {
  0: '4XrerNcLnrMQoFj1ng84LA'
}

export const PRIVACY_POLICIES = {
  0: '1gBANafsqzQgShhsufmhUJ'
}

export const IMAGES = {
  GRAPES: '51iouOm8z3r36I3pytjELy',
  CAKE: 'pDj95bjeNHmvFBjPmj00v',
  LEMON: '2qvnSUuxsCuHrtZxBMEzid',
  PASTA: '1snTvLzRH6Lanwgn2rPWBk',
  BANNER_BALANCE: '5m5SC6M712UXZVHamnzZRx',
  BANNER_GIFTCARD: 'Z69b9qmcTUO2cMT3BSV1D',
  ORANGE: '5diCU7Yi85jeMyxlojAqFd'
}

export const GIFTCARDS = {
  COLLAGE: '3ImHakUNnUdvFNbAmuUjN0',
  HOME: '5Njr3wzDDfEMz9sMz9gHdN',
  ENTRYID_VALUES: '3CySaVY8lg4CYqA9Lc19z8',
  VALUES: ['$5.000', '$10.000', '$20.000', '$30.000', '$50.000', '$100.000'],
  QUANTITY: ['2', '3', '4', '5', '6', '7', '8', '9', '10']
}
